import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  isLoading,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-[#E63946] text-white hover:bg-[#d62839] focus:ring-[#E63946] shadow-md hover:shadow-lg',
    secondary: 'bg-[#FDB913] text-black hover:bg-[#e5a80f] focus:ring-[#FDB913] shadow-md hover:shadow-lg',
    outline: 'border-2 border-[#FDB913] text-[#FDB913] hover:bg-[#FDB913] hover:text-black',
    ghost: 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} disabled={disabled || isLoading} {...props} data-id="element-215">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-216" />}
      {children}
    </button>;
}